import { IconProps } from "@/common/contracts/icon.contracts";

export const Check = (props: IconProps) => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M18.3 6.3L9 15.6L5.7 12.3C5.3 11.9 4.7 11.9 4.3 12.3C3.9 12.7 3.9 13.3 4.3 13.7L8.3 17.7C8.5 17.9 8.7 18 9 18C9.3 18 9.5 17.9 9.7 17.7L19.7 7.7C20.1 7.3 20.1 6.7 19.7 6.3C19.3 5.9 18.7 5.9 18.3 6.3Z"
        fill="currentColor"
      />
    </svg>
  );
};
